<template>
    <div id="pageRoot">

        <h2 id="text01">
            Nadie sabe donde vive,<br>
            Nadie en la casa lo vio,<br>
            pero todos escuchamos,<br>
            al sapito: glo glo glo. 
        </h2>
        <h2 id="text02">
            ¿Vivirá en la chimenea?<br>
            ¿Donde diablos se escondió?<br>
            ¿Donde canta cuando llueve,<br>
            el sapito Glo Glo Glo?
        </h2>
        
        <!-- SVG BACKGROUND-------------------------------------------------------->

        <img src="/pages/img/sordoglo/svgGlo3Clouds.svg" id="clouds" class="pageElement">
        <img src="/pages/img/sordoglo/svgGlo3Trees.svg" id="trees" class="pageElement">
        <img src="/pages/img/sordoglo/svgGlo3School.svg" id="school" class="pageElement">
        <img src="/pages/img/sordoglo/svgGlo3Street.svg" id="street" class="pageElement">
        <img src="/pages/img/sordoglo/svgGlo3DogWmn.svg" id="dogWmn" class="pageElement">
        <img src="/pages/img/sordoglo/svgGlo3Car.svg" id="car" class="pageElement">
        <img src="/pages/img/sordoglo/svgGlo1Rain.svg" id="rain01" class="pageElement">
        <img src="/pages/img/sordoglo/svgGlo3Rain02.svg" id="rain02" class="pageElement">
        <img src="/pages/img/sordoglo/svgGlo3Title.svg" id="title" class="pageElement">
        <img src="/pages/img/sordoglo/svgGlo3GloGlobe.svg" id="gloGlobe" class="pageElement">
    </div>
</template>
<style scoped>
#text01{
    position: absolute;
    left: 635px;
    top: 39px;
}
#text02{
    position: absolute;
    left: 637px;
    top: 197px;
}

#clouds{
    position: absolute;
    left: 5px;
    top: 19px;
}
#trees{
    position: absolute;
    left: 234px;
    top: 36px;
}
#school{
    position: absolute;
    width: 507.78px;
    height: 391.5px;
    left: 12px;
    top: 206px;
}
#street{
    position: absolute;
    left: 5px;
    top: 585px;
}
#dogWmn{
    position: absolute;
    left: 72px;
    top: 395px;
}
#car{
    position: absolute;
    left: 522px;
    top: 510px;
}
#rain01{
    position: absolute;
    width: 790px;
    height: 690px;
    left: -106px;
    top: -70px;
}
#rain02{
    position: absolute;
    left: 488px;
    top: 334px;
}
#title{
    position: absolute;
    left: 10px;
    top: 35px;
    z-index: 3;
}
#gloGlobe{
    position: absolute;
    left: 516px;
    top: 371px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["glo/Video 3b.mp4"]
    }
  }
}
</script>